import React from "react";
import { Clock, Layers, Lock, ShieldCheck, Zap } from "lucide-react";

const CARDS = [
  {
    icon: ShieldCheck,
    title: "Verified Listings",
    description: "Every space and provider on SPACIA is verified, so you always know what to expect.",
  },
  {
    icon: Zap,
    title: "Instant Booking",
    description: "Real-time availability and secure online payments mean no waiting, no back-and-forth.",
  },
  {
    icon: Clock,
    title: "Built for Flexibility",
    description: "Book by the hour, the night or the month. SPACIA adapts to how you work, stay and play.",
  },
  {
    icon: Lock,
    title: "Built by theSOFTtribe",
    description: "Enterprise-grade security and reliability behind every booking.",
  },
];

export default function WhyChooseSection() {
  return (
    <section className="bg-[#f5f8ff] py-20">
      <div className="mx-auto max-w-[1440px] px-[16px] sm:px-8">
        <p className="text-[14px] font-semibold uppercase leading-5 tracking-[1.4px] text-[#017bef]">Why SPACIA</p>
        <h2 className="pt-[12px] text-[36px] font-bold leading-[48px] tracking-[-1.2px] text-[#0a0a0a] sm:text-[48px]">
          Why Choose SPACIA
        </h2>

        <div className="grid grid-cols-1 gap-[20px] pt-12 md:grid-cols-2 lg:grid-cols-3 lg:grid-rows-2">
          <div className="overflow-hidden rounded-3xl border-[1px] border-solid border-[#e5e7eb] bg-white md:col-span-2 lg:col-span-1 lg:row-span-2">
            <img
              src="/figma-assets/home/why-one-platform.jpg"
              alt="One Platform, Every Space"
              className="h-64 w-full object-cover"
            />
            <div className="p-8">
              <div className="flex size-11 items-center justify-center rounded-[14px] bg-[#017bef]/10">
                <Layers className="size-[22px] text-[#017bef]" />
              </div>
              <h3 className="pt-[20px] text-[20px] font-bold leading-[27.5px] text-[#0a0a0a]">
                One Platform, Every Space
              </h3>
              <p className="pt-[12px] text-[16px] leading-[26px] text-[#717182]">
                Discover and book workspaces, accommodation and experiences without switching between apps.
              </p>
            </div>
          </div>

          {CARDS.map(({ icon: Icon, title, description }) => (
            <div key={title} className="rounded-3xl border-[1px] border-solid border-[#e5e7eb] bg-white p-7">
              <div className="flex size-11 items-center justify-center rounded-[14px] bg-[#017bef]/[0.08]">
                <Icon className="size-5 text-[#017bef]" />
              </div>
              <h3 className="pt-[20px] text-[18px] font-bold leading-[27px] text-[#0a0a0a]">{title}</h3>
              <p className="pt-2 text-[14px] leading-[22.75px] text-[#717182]">{description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
